import { useConfig } from "../authHooks";
import { redirectToProvider } from "../api_client/allauth";
import Button from "@sharpana/ui/Button";
import { isWebExtension } from "@sharpana/shared/utils/web_environment";
import GoogleSignInButton from "./GoogleSignInButton";
import AppleSignInButton from "./AppleSignInButton";
import { useMemo } from "react";

export default function ProviderList(props: any) {
  const config = useConfig();
  const providers = config.data.socialaccount.providers;
  if (!providers.length) {
    return null;
  }

  const flowDescription = props.flowDescription
    ? props.flowDescription
    : "Sign in";

  const openLoginPopup = (providerId: string) => {
    // alert('clicked')
    const popupWinWidth: any = "460";
    const popupWinHeight: any = "650";
    // eslint-disable-next-line no-restricted-globals
    let left = (screen.width - popupWinWidth) / 2;
    // eslint-disable-next-line no-restricted-globals
    let top = (screen.height - popupWinHeight) / 4;
    const windowFeatures =
      "left=" +
      left +
      ",top=" +
      top +
      ",width=" +
      popupWinWidth +
      ",height=" +
      popupWinHeight;
    const handle = window.open(
      `/account/login-web-extension/provider/popup/${providerId}`,
      "social-login-popup",
      windowFeatures
    );
    if (!handle) {
      // The window wasn't allowed to open
      // This is likely caused by built-in popup blockers.
      // …
    }
  };

  const isOnWebExtension = isWebExtension();

  const handleOnClick = (providerId: string) => {
    if (isOnWebExtension) {
      openLoginPopup(providerId); // web extension runs inside an iframe, most providers don't work inside iframes
    } else {
      redirectToProvider(providerId, props.callbackURL, props.process);
    }
  };

  // Build a filtered list to ensure only one Apple button shows on web.
  // Which is necessary because some paths can create multiple SocialApp
  // objects for different platforms (e.g. web android [see mobile_apple_code_exchange_login()]
  // which can then conflict with the web regular one, since both use the same client_id)
  // Strategy:
  // - Skip the iOS-native Apple entry (bundle ID "ai.mrble.sharpana").
  // - Dedupe Apple by client_id to avoid showing both settings and DB entries for the same client_id.
  // - Preserve the original intention where Google shows above Apple by reversing first, then keeping the first unique.
  const filteredProviders = useMemo(() => {
    const reversed = [...providers].reverse();
    const seenAppleClientIds = new Set<string>();
    const out: any[] = [];
    for (const p of reversed) {
      if (p.name === "Apple") {
        const clientId = p.client_id || "";
        // Skip iOS-native Apple app on web
        if (clientId === "ai.mrble.sharpana") {
          continue;
        }
        // Drop duplicate Apple entries for the same client_id (e.g., settings + DB)
        if (seenAppleClientIds.has(clientId)) {
          continue;
        }
        seenAppleClientIds.add(clientId);
      }
      out.push(p);
    }
    return out;
  }, [providers]);

  return (
    <>
      {/* Already reversed inside filteredProviders to keep Google above Apple */}
      {filteredProviders.map((provider: any) => {
        return (
          <div key={provider.id}>
            <div onClick={() => handleOnClick(provider.id)}>
              {provider.name == "Google" ? (
                <GoogleSignInButton text={flowDescription} />
              ) : provider.name == "Apple" ? (
                <AppleSignInButton text={flowDescription} />
              ) : (
                <>{provider.name}</>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}
